import Space from 'antd/es/space';
import Typography from 'antd/es/typography';
import React from 'react';
import styled from 'styled-components';

import {
  SectionHeader,
  SectionTitle,
} from '../../../components/TaskDescription';

const { Paragraph, Text } = Typography;

const ContentSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ThoughtContainer = styled.div`
  background-color: ${(props) => props.theme.token.colorPrimaryBg};
  border-left: 4px solid ${(props) => props.theme.token.colorPrimary};
  padding: 16px;
  margin: 12px 0;
  border-radius: 0 8px 8px 0;
`;

interface ThoughtProcessProps {
  thoughts: string[];
}

const ThoughtProcess: React.FC<ThoughtProcessProps> = ({ thoughts }) => {
  if (!thoughts || thoughts.length === 0) {
    return null;
  }

  return (
    <ContentSection>
      <SectionHeader>
        <SectionTitle level={4} style={{ margin: 0 }}>
          Thought Process
        </SectionTitle>
      </SectionHeader>
      <Space direction="vertical" style={{ width: '100%' }}>
        {thoughts.map((thought, index) => (
          <ThoughtContainer key={index}>
            <Paragraph>
              <Text type="secondary">{`Step ${index + 1}`}</Text>
              <div>{thought}</div>
            </Paragraph>
          </ThoughtContainer>
        ))}
      </Space>
    </ContentSection>
  );
};

export default ThoughtProcess;
